import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-onboarding-entrance',
    templateUrl: './onboarding-entrance.component.html',
    styleUrls: ['./onboarding-entrance.component.sass']
})
export class OnboardingEntranceComponent implements OnInit {

    constructor() { }

    ngOnInit() {}

}
